module.exports = __webpack_public_path__ + "static/media/SmartShop_2-264w.0680f47b.png";